import './crypto.js';

//获取链接get值
export function getParamString(name) {
    var paramUrl = window.location.href.split("?");
    var params = {};
    if(paramUrl.length>1){
        var paramStrs = paramUrl[1].split('&');
        for(var index = 0; index < paramStrs.length; index++) {
            params[paramStrs[index].split('=')[0]] = decodeURI(paramStrs[index].split('=')[1]);
        }
    }
	return params[name];
}
//写入cookies
export function setCookie(name,value,Hours){
    var cook = name + "=" + escape(value);
    if(Hours > 0){//等于0时，关闭浏览器自动清除Cookies.
        var date = new Date();
        var ms = Hours*24*60*60*1000;
        date.setTime(date.getTime() + ms);
        cook += "; expires=" + date.toGMTString();
    }
    document.cookie = cook;
}
//读取cookies
export function getCookie(name){
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg)){
        return unescape(arr[2]);
    }
    return null;
}
//删除cookies
export function delCookie(name){
    var exp = new Date();
    exp.setTime(exp.getTime() + (-1*24*60*60*1000));
    var expires = "expires="+exp.toUTCString();

    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    var cooki=null;
    if(arr=document.cookie.match(reg)){
        cooki = unescape(arr[2]);
    }
    if(cooki!=null){
        document.cookie= name + "='';"+expires;
        console.log(name + "='';"+expires);
    }
}
//判断学历层次
export function type_change(type){
    switch (type){
        case 1:
            return '专科';
        case 2:
            return '本科';
        case 3:
            return '研究生';
        default:
            return '层次';
    }
}
//判断返回中文学期
export function qiZh(i){
    switch (i){
        case 1:
            return '一';break;
        case 2:
            return '二';break;
        case 3:
            return '三';break;
        case 4:
            return '四';break;
        case 5:
            return '五';break;
        case 6:
            return '六';break;
        case 7:
            return '七';break;
        case 8:
            return '八';break;
        case 9:
            return '九';break;
        case 10:
            return '十';break;
    }
}
//退出登录
export function loginOutFn(that, type){
    //that=this  type=跳转方式
	that.$cookies.remove("token");
	that.$cookies.remove("school_logo");
    let query = {}
        ,query_str = ''
    // if(that.$store.state.school_id == 12){
    //     query.school = 'zsc'
    // }
    that.$store.commit("user_relation_count",'')
	if(type=="location"){
        let href = window.location.origin + '/web/'
        // for(let key in query){
        //     query_str += key + '=' + query[key]
        // }
        // if(query_str != ''){
        //     href = href + "?" + query_str
        // }
		self.location.href = href
	}else if(type=="route"){
		that.$router.push({
            path:"/web/login",
            query:query
        })
		// that.$router.push("/web/login")
	}
}
//获取用户数据
function getuserdata(that, callFn){
    var token=that.$cookies.get("token")
        // ,grade_id = parseInt(that.$store.state.grade_id)
    
    // if(!grade_id){
    //     return false
    // }
    //获取用户数据
    const url = that.global.serverSrc+that.global.qianzui+'/member/detail';
    that.$ajax.get(url)
    .then(function(res){
        let resData=res.data;
        if(resData.code==0){
            that.global.uDetailData = resData.data;
            that.$cookies.set("school_logo", resData.data.school.school_logo)
            that.$store.commit("change_vuex",{
                key:"school_logo",
                value:resData.data.school.school_logo
            })
            if(typeof callFn == "function"){
                callFn(resData)
            }
        }else if(resData.code==401){
            that.$message.error('请求错误，请重新登录');
            that.$selfjs.loginOutFn(that, "route")
        }else{
            that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
        }
    })
}
export function getUserCallFn(that, callFn){
    let uDetailData = that.global.uDetailData
    if(uDetailData.school && uDetailData!=""){
        callFn(uDetailData)
    }else{
        getuserdata(that,function(resData){
            callFn(resData.data)
        })
    }
}
//获取用户身份列表
async function getIdentity(that, callFn){
    var token=that.$cookies.get("token")
    
    //获取用户数据
    const url = that.global.serverSrc+that.global.qianzui+'/member/identity_list';
    await that.$ajax.get(url)
    .then(function(res){
        let resData=res.data;
        if(resData.code==0){
            that.global.identity_list = resData.data;
            if(typeof callFn == "function"){
                callFn(resData.data)
            }
        }else if(resData.code==401){
            that.$message.error('请求错误，请重新登录');
            that.$selfjs.loginOutFn(that, "route")
        }else{
            that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
        }
    })
}
//获取用户身份列表
export function getIdentityCallFn(that, callFn){
    let identity_list = that.global.identity_list
    if(identity_list){
        callFn(identity_list)
    }else{
        getIdentity(that,function(resData){
            callFn(resData)
        })
    }
}
//根据身份ID判断网站内容
export function idswitch(that,item) {
    let id = item.id,
        grade_id = item.list[0].grade_id,
        // hideType = 1
        hideType = id
    // 1、成考入学辅导
    // 2、研究生入学辅导的学习模板
    // 3、成考的学习模板
    // 4、自考的学习模板
    // 5、职业培训考证的学习模板
    // 6、研究生入学后的学习模板
    // 7、初级会计师证
    // 8、教师资格证学校模板
    // 9、教育硕士
    // 10、农业硕士
    //修改身份ID
    that.$cookies.set("identity", id)
    that.$store.commit("change_vuex",{
        key:"identity",
        value:id
    })
    //修改班级ID
    that.$cookies.set("grade_id", grade_id)
    // that.$store.commit("change_vuex",{
    //     key:"grade_id",
    //     value:grade_id
    // })
    // console.log(that.$store.state);
    //修改模板ID
    that.$cookies.set("hideType", hideType)
    that.$store.commit("change_vuex",{
        key:"hideType",
        value:hideType
    })
    if(hideType == 3 || hideType == 13){
        that.$store.commit("temp",{
            key:"head.menu.exam_list",
            value: true
        })
    }
    //修改LOGO
    // that.$cookies.set("school_logo", item.list[0].logo)
    // that.$store.commit("change_vuex",{
    //     key:"school_logo",
    //     value:item.list[0].logo
    // })
}
//根据身份证号码获取出生日期
export function getBirth(idCard) {
    var birthday = "";
  if(idCard != null && idCard != "" && idCard.length >= 15){
      if(idCard.length == 15){
          birthday = "19"+idCard.slice(6,12);
      } else if(idCard.length == 18){
          birthday = idCard.slice(6,14);
      }	
      birthday = birthday.replace(/(.{4})(.{2})/,"$1年$2月");
      birthday += "日"
      //通过正则表达式来指定输出格式为:1990-01-01
  }	
  return birthday;
}
//根据身份证号码获取性别
export function getSex(idCard) {
	var sexStr = '';
    if(idCard.length >= 15){
        if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
            sexStr = '男';
        }
        else {
            sexStr = '女';
        }
    }
	return sexStr;
}
//顶部导航跳转
export function swhead(that,key,querydata){
    var queryObj = {page:key}
    if(querydata){
        queryObj = {...queryObj,...querydata}
    }
    if(key.length>3){
        //路由跳转
        that.$router.push({
            path: key,
            name: key,
            query: queryObj
        })

        //清除全部计时器
        for(var each in that.global.pageTimer){
            clearInterval(that.global.pageTimer[each]);
        }
    }
}
//点击当前位置的跳转函数
export function jumpPage(that, args){
    let obj={
        path: args.router,
        name: args.name,
    }
    if(args.query){
        obj.query=args.query
    }
    that.$store.commit("activeIndex", args.activeIndex || args.name)	//初始化导航值
    that.$router.push(obj)
}
//学期选择点击
export function qiSelect(that, qioption, callFn){
    var qiFocus = that.$store.state.qiFocus
    if(qiFocus==""){
        that.$store.commit("qiFocus","focus")
    }else{
        that.$store.commit("qiFocus","")
        if(typeof callFn == "function"){
            callFn(qioption)
        }
    }
}

//获取与毫秒数的转化比例（相差天数：1，相差小时数：2，相差分钟数：3，相差秒数：4）
var getDifferScale = function (value) {
    var format;
    //获取转化比（天数跟毫秒数的比例）
    if (value == 1) {
        format = parseFloat(24 * 60 * 60 * 1000);
    }
        //获取转化比（小时数跟毫秒数的比例）
    else if (value == 2) {
        format = parseFloat(60 * 60 * 1000);
    }
        //获取转化比（分钟数跟毫秒数的比例）
    else if (value == 3) {
        format = parseFloat(60 * 1000);
    }
        //获取转化比（秒数跟秒数的比例）
    else if (value == 4) {
        format = parseFloat(1000);
    }
    return format;
}

//获取两个日期的相差日期数(differ 相差天数：1、相差小时数：2、相差分钟数：3、相差秒数：4)
export function getDifferDate(firstDate, secondDate, differ) {
    //1)将两个日期字符串转化为日期对象
    var startDate = new Date(firstDate);
    var endDate = new Date(secondDate);
    //2)计算两个日期相差的毫秒数
    var msecNum = endDate.getTime() - startDate.getTime();
    //3)计算两个日期相差的天数
    var dayNum = Math.floor(msecNum /getDifferScale(differ));
    return dayNum;
}

//秒转换成日时分秒
export function secondsFormat(s,option) { 
    let defa_option = {
        format :"DD天H时M分S秒"
    }
    option = Object.assign({},defa_option,option)
    // if(s){
        var day
        if(option.format){
            day = option.format.indexOf("DD") > -1 ? Math.floor( s/ (24*3600) ) : 0 // Math.floor()向下取整 
        }
        // var day = Math.floor( s/ (24*3600) ); // Math.floor()向下取整 
        var hour = Math.floor( (s - day*24*3600) / 3600); 
        var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 ); 
        var second = s - day*24*3600 - hour*3600 - minute*60; 
        if(option){
            if(option.format){
                let resCon = option.format
                resCon = resCon.replace(/DD/,day)
                resCon = resCon.replace(/H/,hour)
                resCon = resCon.replace(/M/,minute)
                resCon = resCon.replace(/S/,second)
                return resCon
            }
        }
        return day + "天"  + hour + "时" + minute + "分" + second + "秒"; 
    // }else{
    // 	return 0 + "天"  + 0 + "时" + 0 + "分" + 0 + "秒"; 
    // }
}
// 获取随机字符串
function random_string(len) {
    len = len || 32;
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';   
    var maxPos = chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}
export function createOssFileName(len) {
    len = len || 20;
    return random_string(len)+new Date().getTime();
}
const KEY_TOKEN = 'token'
export function getToken () {
  return localStorage.getItem(KEY_TOKEN)
}
export function setToken (token) {
  return localStorage.setItem(KEY_TOKEN, token)
}
export function removeToken () {
  return localStorage.removeItem(KEY_TOKEN)
}

function getAesString(data,key,iv){//加密
    var key  = window.CryptoJS.enc.Utf8.parse(key);
    var iv   = window.CryptoJS.enc.Utf8.parse(iv);
    var encrypted =window.CryptoJS.AES.encrypt(data,key,
        {
            iv:iv,
            mode: window.CryptoJS.mode.CBC,
            padding: window.CryptoJS.pad.Pkcs7
        });
    return encrypted.toString();    //返回的是base64格式的密文
}
export function getAES(data){ //加密
    var key  = 'BmqGgcpSyvBli36N';  //密钥   可以修改，自定义
    var iv   = 'u112ZfIPYfFxK49C';      //偏移量   可以修改，自定义
    var encrypted = getAesString(data,key,iv); //密文
    // var encrypted1 = Crypto.enc.Utf8.parse(encrypted);
    return encrypted;
}

//OSS删除
export function delOssFile(that,url_arr,callFn){
    const url = that.global.serverSrc+that.global.qianzui+'/aliyun/del_oss_file';
    that.$ajax.post(url,{
        urls:url_arr
    })
    .then(function(res){
        let resData=res.data;
        if(resData.code==0){
            if(typeof callFn == "function"){
                callFn()
            }
        }else{
            that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
        }
    })
}

// DES: 导出当前对象
export default {
    getParamString
    ,delCookie
    ,setCookie
    ,getCookie
    ,type_change
    ,qiZh
    ,loginOutFn
    ,getUserCallFn
    ,getIdentityCallFn
    ,idswitch
    ,getBirth
    ,getSex
    ,swhead
    ,qiSelect
    ,getToken
    ,setToken
    ,removeToken
    ,getDifferDate
    ,secondsFormat
    ,jumpPage
    ,createOssFileName
    ,getAES
    ,delOssFile
}


// WEBPACK FOOTER //
// ./src/static/js/javascript.js